import { createContext, PropsWithChildren, useContext, useEffect, useRef, useState } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { Button } from '../../_ui/Button'
import { Dialog } from '../../_ui/Dialog'

const ServiceWorkerRegistrationContext = createContext<() => ServiceWorkerRegistration | undefined>(() => undefined)

export const useServiceWorkerRegistration = () => useContext(ServiceWorkerRegistrationContext)

export function PWAUpdatePrompt({ children }: PropsWithChildren) {
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false)
  const serviceWorkerRegistration = useRef<ServiceWorkerRegistration | undefined>(undefined)

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(url, r) {
      serviceWorkerRegistration.current = r
    }
  })

  useEffect(() => {
    if (needRefresh) {
      setShowUpdatePrompt(true)
    }
  }, [needRefresh])

  const close = () => {
    setNeedRefresh(false)
    setShowUpdatePrompt(false)
  }

  const handleUpdate = () => {
    console.log('Updating service worker...')
    updateServiceWorker(true)
  }

  const getCurrentSW = () => {
    return serviceWorkerRegistration.current
  }

  console.log('adsf')

  return (
    <>
      <ServiceWorkerRegistrationContext.Provider value={getCurrentSW}>
        {children}
      </ServiceWorkerRegistrationContext.Provider>
      <Dialog title={'Update verfügbar'} open={showUpdatePrompt} onClose={() => {}} hideCloseButton>
        <div className={'pt-2'}>
          <p className={'text-sm mb-5'}>
            Die Anwendung wurde aktualisiert! Klicke jetzt auf "Jetzt aktualisieren", um die neusten Features und Fehlerbehebungen zu erhalten.
            Anschließend wird die Seite neu geladen und du kannst das Portal weiter wie gewohnt nutzen.
          </p>
          <Button autoFocus onClick={() => handleUpdate()}>Jetzt aktualisieren</Button>
        </div>
      </Dialog>
    </>
  )
}

